
import Vue from "vue";
import { mapState } from "vuex";
import BattleyeR2New from "./BattleyeR2New.vue";
import BattleyeR2NewEn from "./BattleyeR2NewEn.vue";

export default Vue.extend({
  name: "BattleyeR2Entry",
  components: {
    BattleyeR2New,
    BattleyeR2NewEn
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN"
    })
  },
  render(createElement) {
    return createElement(this.isCN ? BattleyeR2New : BattleyeR2NewEn);
  }
});
